import React from 'react'
import {observerFn} from 'src/core/store'
export default observerFn((props) => {
  return (
    <div>
      <h1>404</h1>
    </div>
  )
})



// WEBPACK FOOTER //
// ./core/nomatch.js